function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "./array-findindex";
import React, { Component } from "react";
import PropTypes from "prop-types";
import targetWidths from "./targetWidths";
import constructUrl from "./constructUrl";
import extractQueryParams from "./extractQueryParams";
import { ShouldComponentUpdateHOC } from "./HOCs";
import { compose, config } from "./common";
import { DPR_QUALITY_VALUES } from "./constants";
var PACKAGE_VERSION = "9.0.2";
var NODE_ENV = process.env.NODE_ENV;

var buildKey = function buildKey(idx) {
  return "react-imgix-".concat(idx);
};

var defaultImgixParams = {
  auto: ["format"]
};
var defaultAttributeMap = {
  src: "src",
  srcSet: "srcSet",
  sizes: "sizes"
};

var noop = function noop() {};

var COMMON_PROP_TYPES = {
  className: PropTypes.string,
  onMounted: PropTypes.func,
  htmlAttributes: PropTypes.object
};

var SHARED_IMGIX_AND_SOURCE_PROP_TYPES = _extends({}, COMMON_PROP_TYPES, {
  disableQualityByDPR: PropTypes.bool,
  disableSrcSet: PropTypes.bool,
  disableLibraryParam: PropTypes.bool,
  imgixParams: PropTypes.object,
  sizes: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  src: PropTypes.string.isRequired
});
/**
 * Validates that an aspect ratio is in the format w:h. If false is returned, the aspect ratio is in the wrong format.
 */


function aspectRatioIsValid(aspectRatio) {
  if (typeof aspectRatio !== "string") {
    return false;
  }

  return /^\d+(\.\d+)?:\d+(\.\d+)?$/.test(aspectRatio);
}

var setParentRef = function setParentRef(parentRef, el) {
  if (!parentRef) {
    return;
  } // assign ref based on if it's a callback vs object


  if (typeof parentRef === "function") {
    parentRef(el);
  } else {
    parentRef.current = el;
  }
};

var buildSrcSetPairWithFixedHeight = function buildSrcSetPairWithFixedHeight(url, targetWidth, fixedHeight, _) {
  return url + "&h=" + fixedHeight + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildSrcSetPairWithTargetWidth = function buildSrcSetPairWithTargetWidth(url, targetWidth, _1, _2) {
  return url + "&w=" + targetWidth + " " + targetWidth + "w";
};

var buildDprSrcWithQuality = function buildDprSrcWithQuality(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithoutQuality = function buildDprSrcWithoutQuality(url, _, dpr) {
  return url + "&dpr=" + dpr + " " + dpr + "x";
};

var buildDprSrcWithQualityByDpr = function buildDprSrcWithQualityByDpr(url, quality, dpr) {
  return url + "&q=" + quality + "&dpr=" + dpr + " " + dpr + "x";
};
/**
 * Build a imgix source url with parameters from a raw url
 */


function buildSrc(_ref) {
  var inputSrc = _ref.src,
      width = _ref.width,
      height = _ref.height,
      disableLibraryParam = _ref.disableLibraryParam,
      disableSrcSet = _ref.disableSrcSet,
      imgixParams = _ref.imgixParams,
      disableQualityByDPR = _ref.disableQualityByDPR;
  var fixedSize = width != null || height != null;

  var _extractQueryParams = extractQueryParams(inputSrc),
      _extractQueryParams2 = _slicedToArray(_extractQueryParams, 2),
      rawSrc = _extractQueryParams2[0],
      params = _extractQueryParams2[1];

  var srcOptions = _extends({}, params, imgixParams, disableLibraryParam ? {} : {
    ixlib: "react-".concat(PACKAGE_VERSION)
  }, fixedSize && height ? {
    height: height
  } : {}, fixedSize && width ? {
    width: width
  } : {});

  var src = constructUrl(rawSrc, srcOptions);
  var srcSet;

  if (disableSrcSet) {
    srcSet = src;
  } else {
    if (fixedSize) {
      var q = srcOptions.q,
          urlParams = _objectWithoutProperties(srcOptions, ["q"]);

      var constructedUrl = constructUrl(rawSrc, urlParams);
      var srcFn = buildDprSrcWithQualityByDpr;

      if (q) {
        srcFn = buildDprSrcWithQuality;
      } else if (disableQualityByDPR) {
        srcFn = buildDprSrcWithoutQuality;
      }

      srcSet = "";
      var len = DPR_QUALITY_VALUES.length;

      for (var _i2 = 0; _i2 < len; _i2++) {
        var quality = DPR_QUALITY_VALUES[_i2];
        srcSet += srcFn(constructedUrl, q || quality, _i2 + 1) + ", ";
      }

      srcSet = srcSet.slice(0, -2);
    } else {
      var _width = srcOptions.width,
          w = srcOptions.w,
          _height = srcOptions.height,
          _urlParams = _objectWithoutProperties(srcOptions, ["width", "w", "height"]);

      var _constructedUrl = constructUrl(rawSrc, _urlParams);

      var aspectRatio = imgixParams.ar;
      var showARWarning = aspectRatio != null && aspectRatioIsValid(aspectRatio) === false;
      var _srcFn = buildSrcSetPairWithTargetWidth;

      if (_height) {
        _srcFn = buildSrcSetPairWithFixedHeight;
      }

      srcSet = "";
      var _len = targetWidths.length;

      for (var _i3 = 0; _i3 < _len; _i3++) {
        var targetWidth = targetWidths[_i3];
        srcSet += _srcFn(_constructedUrl, targetWidth, _height) + ", ";
      }

      srcSet = srcSet.slice(0, -2);

      if (NODE_ENV !== "production" && showARWarning && config.warnings.invalidARFormat) {
        console.warn("[Imgix] The aspect ratio passed (\"".concat(aspectRatio, "\") is not in the correct format. The correct format is \"W:H\"."));
      }
    }
  }

  return {
    src: src,
    srcSet: srcSet
  };
}
/**
 * Combines default imgix params with custom imgix params to make a imgix params config object
 */


function imgixParams(props) {
  var params = _extends({}, defaultImgixParams, props.imgixParams);

  return _extends({}, params);
}
/**
 * React component used to render <img> elements with Imgix
 */


var ReactImgix =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactImgix, _Component);

  function ReactImgix(props) {
    var _this;

    _classCallCheck(this, ReactImgix);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactImgix).call(this, props));
    _this.imgRef = null;
    return _this;
  }

  _createClass(ReactImgix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.imgRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _extends2;

      var _this$props = this.props,
          disableSrcSet = _this$props.disableSrcSet,
          type = _this$props.type,
          width = _this$props.width,
          height = _this$props.height; // Pre-render checks

      if (NODE_ENV !== "production" && config.warnings.sizesAttribute) {
        if (this.props.width == null && this.props.height == null && this.props.sizes == null && !this.props._inPicture) {
          console.warn("If width and height are not set, a sizes attribute should be passed.");
        }
      }

      var _buildSrc = buildSrc(_extends({}, this.props, {
        type: "img",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc.src,
          srcSet = _buildSrc.srcSet;

      var attributeConfig = _extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = _extends({}, this.props.htmlAttributes, (_extends2 = {}, _defineProperty(_extends2, attributeConfig.sizes, this.props.sizes), _defineProperty(_extends2, "className", this.props.className), _defineProperty(_extends2, "width", width <= 1 ? null : width), _defineProperty(_extends2, "height", height <= 1 ? null : height), _defineProperty(_extends2, attributeConfig.src, src), _defineProperty(_extends2, "ref", function ref(el) {
        _this2.imgRef = el;

        if (_this2.props.htmlAttributes !== undefined && "ref" in _this2.props.htmlAttributes) {
          setParentRef(_this2.props.htmlAttributes.ref, _this2.imgRef);
        }
      }), _extends2));

      if (!disableSrcSet) {
        childProps[attributeConfig.srcSet] = srcSet;
      }

      return React.createElement("img", childProps);
    }
  }]);

  return ReactImgix;
}(Component);

_defineProperty(ReactImgix, "propTypes", _extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

_defineProperty(ReactImgix, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

ReactImgix.displayName = "ReactImgix";
/**
 * React component used to render <picture> elements with Imgix
 */

var PictureImpl =
/*#__PURE__*/
function (_Component2) {
  _inherits(PictureImpl, _Component2);

  function PictureImpl(props) {
    var _this3;

    _classCallCheck(this, PictureImpl);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PictureImpl).call(this, props));
    _this3.pictureRef = null;
    return _this3;
  }

  _createClass(PictureImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.pictureRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children; // make sure all of our children have key set, otherwise we get react warnings

      var _children = React.Children.map(children, function (child, idx) {
        return React.cloneElement(child, {
          key: buildKey(idx),
          _inPicture: true
        });
      }) || [];
      /*
      We need to make sure an <img /> or <Imgix /> is the last child so we look for one in children
        a. if we find one, move it to the last entry if it's not already there
        b. if we don't find one, warn the user as they probably want to pass one.
      */
      // look for an <img> or <ReactImgix type='img'> - at the bare minimum we have to have a single <img> element or else it will not work.


      var imgIdx = _children.findIndex(function (c) {
        return c.type === "img" || c.type === ReactImgix || c.type === ReactImgixWrapped;
      });

      if (imgIdx === -1 && config.warnings.fallbackImage) {
        console.warn("No fallback <img /> or <Imgix /> found in the children of a <picture> component. A fallback image should be passed to ensure the image renders correctly at all dimensions.");
      } else if (imgIdx !== _children.length - 1) {
        // found one, need to move it to the end
        _children.push(_children.splice(imgIdx, 1)[0]);
      }

      return React.createElement("picture", {
        ref: function ref(el) {
          return _this4.pictureRef = el;
        },
        children: _children
      });
    }
  }]);

  return PictureImpl;
}(Component);

_defineProperty(PictureImpl, "propTypes", _extends({}, COMMON_PROP_TYPES, {
  children: PropTypes.any
}));

_defineProperty(PictureImpl, "defaultProps", {
  onMounted: noop
});

PictureImpl.displayName = "ReactImgixPicture";
/**
 * React component used to render <source> elements with Imgix
 */

var SourceImpl =
/*#__PURE__*/
function (_Component3) {
  _inherits(SourceImpl, _Component3);

  function SourceImpl(props) {
    var _this5;

    _classCallCheck(this, SourceImpl);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(SourceImpl).call(this, props));
    _this5.sourceRef = null;
    return _this5;
  }

  _createClass(SourceImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMounted(this.sourceRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
          _extends3;

      var _this$props2 = this.props,
          disableSrcSet = _this$props2.disableSrcSet,
          width = _this$props2.width,
          height = _this$props2.height;

      var _buildSrc2 = buildSrc(_extends({}, this.props, {
        type: "source",
        imgixParams: imgixParams(this.props)
      })),
          src = _buildSrc2.src,
          srcSet = _buildSrc2.srcSet;

      var attributeConfig = _extends({}, defaultAttributeMap, this.props.attributeConfig);

      var childProps = _extends({}, this.props.htmlAttributes, (_extends3 = {}, _defineProperty(_extends3, attributeConfig.sizes, this.props.sizes), _defineProperty(_extends3, "className", this.props.className), _defineProperty(_extends3, "width", width <= 1 ? null : width), _defineProperty(_extends3, "height", height <= 1 ? null : height), _defineProperty(_extends3, "ref", function ref(el) {
        _this6.sourceRef = el;

        if (_this6.props.htmlAttributes !== undefined && "ref" in _this6.props.htmlAttributes) {
          setParentRef(_this6.props.htmlAttributes.ref, _this6.sourceRef);
        }
      }), _extends3)); // inside of a <picture> element a <source> element ignores its src
      // attribute in favor of srcSet so we set that with either an actual
      // srcSet or a single src


      if (disableSrcSet) {
        childProps[attributeConfig.srcSet] = src;
      } else {
        childProps[attributeConfig.srcSet] = "".concat(srcSet);
      } // for now we'll take media from htmlAttributes which isn't ideal because
      //   a) this isn't an <img>
      //   b) passing objects as props means that react will always rerender
      //      since objects dont respond correctly to ===


      return React.createElement("source", childProps);
    }
  }]);

  return SourceImpl;
}(Component);

_defineProperty(SourceImpl, "propTypes", _extends({}, SHARED_IMGIX_AND_SOURCE_PROP_TYPES));

_defineProperty(SourceImpl, "defaultProps", {
  disableSrcSet: false,
  onMounted: noop
});

SourceImpl.displayName = "ReactImgixSource";
var ReactImgixWrapped = compose(ShouldComponentUpdateHOC)(ReactImgix);
var Picture = compose(ShouldComponentUpdateHOC)(PictureImpl);
var Source = compose(ShouldComponentUpdateHOC)(SourceImpl);
export default ReactImgixWrapped;
export { ReactImgix as __ReactImgixImpl // for testing
, Picture, Source, SourceImpl as __SourceImpl // for testing
, PictureImpl as __PictureImpl // for testing
};
//# sourceMappingURL=react-imgix.js.map